import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Activity from './pages/Activity';
import Contact from './pages/Contact';
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBtTzaQtUAcq0jXMi1B4HPaAdlZB6zQ2Hw",
  authDomain: "shipmentplatform.firebaseapp.com",
  projectId: "shipmentplatform",
  storageBucket: "shipmentplatform.firebasestorage.app",
  messagingSenderId: "1012977719233",
  appId: "1:1012977719233:web:5a65bc863cac80bc068140",
  measurementId: "G-1V31E98933"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Import the functions you need from the SDKs you need

// Import the functions you need from the SDKs you nee
function App() {

  const [formSubmitted, setFormSubmitted] = useState(false);

  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home formSubmitted={formSubmitted} setFormSubmitted={setFormSubmitted} />} />
            <Route path="/about" element={<About />} />
            <Route path="/activity" element={<Activity />} />
            <Route path="/contact" element={<Contact formSubmitted={formSubmitted} setFormSubmitted={setFormSubmitted} />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;


